/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, shape, string } from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Drawer from '@material-ui/core/Drawer';
import { useDispatch, useSelector } from 'react-redux';

import SearchV3 from '../SearchV3';
import { setSearchV3DrawerOpened } from '../../../../../state/ducks/App/App-Actions';
import { getSearchV3DrawerOpened } from '../../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles(() => ({
    drawerRoot: {
        zIndex: '999999 !important',
    },
    drawerPaper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
}));

const MobileSearchDrawer = ({ brand }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const isSearchV3DrawerOpened = useSelector(getSearchV3DrawerOpened);

    const handleClose = () => {
        dispatch(setSearchV3DrawerOpened(false));
    };

    return (
        <Drawer
            anchor="bottom"
            classes={{
                paper: classes.drawerPaper,
                root: classes.drawerRoot,
            }}
            open={isSearchV3DrawerOpened}
            ModalProps={{
                keepMounted: true,
            }}
            onClose={handleClose}
            transitionDuration={0}
        >
            <SearchV3 brand={brand} handleMobileClose={handleClose} autoFocus={isSearchV3DrawerOpened} />
        </Drawer>
    );
};

MobileSearchDrawer.propTypes = {
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
};

export default MobileSearchDrawer;
